import { render, staticRenderFns } from "./ProductSalesReport.vue?vue&type=template&id=37b7bd26"
import script from "./ProductSalesReport.vue?vue&type=script&lang=js"
export * from "./ProductSalesReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports